import React from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const Modal = ({
    children,
    footerComponent: FooterComponent = null,
    onEnter,
    onExited,
    onHide,
    show,
    size = 'lg',
    title,
}) => (
    <Dialog
        footerComponent={FooterComponent}
        onClose={() => onHide()}
        onEnter={onEnter}
        onExited={onExited}
        open={show}
        size={size}
        title={title}
    >
        {children}
    </Dialog>
);

Modal.propTypes = {
    children: PropTypes.node,
    footerComponent: PropTypes.node,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
    onHide: PropTypes.func,
    show: PropTypes.bool,
    size: PropTypes.string,
    title: PropTypes.string,
};

export default Modal;
